// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__aOmNj","wrapper":"App_wrapper__3ox-V"};